"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ProductImage = require("./ProductImage");
Object.keys(_ProductImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProductImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProductImage[key];
    }
  });
});
